<template>
  <span>
    <button
      @click="isActive = !isActive"
      class="button is-small"
    >
      <span class="icon">
        <i class="far fa-play-circle"></i>
      </span>
      <span>{{ $t('common.start') }}</span>
    </button>
    <div
      v-if="isActive"
      class="modal"
      :class="{ 'is-active': isActive }"
    >
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">{{ $t('common.startFor', { target: $t('term.drill') }) }}</p>
          <button
            @click="isActive = !isActive"
            class="delete"
            aria-label="close"
          ></button>
        </header>
        <section class="modal-card-body py-6">
          <PostStart :category-slug="categorySlug" />
        </section>
        <footer class="modal-card-foot">
          <button
            class="button"
            @click="isActive = !isActive"
          >
            Cancel
          </button>
        </footer>
      </div>
    </div>
  </span>
</template>
<script>
import PostStart from '@/components/organisms/PostStart'

export default {
  name: 'DrillStartModal',

  components: {
    PostStart,
  },

  props: {
    categorySlug: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      isActive: false,
    }
  },
  created() {},
}
</script>
